import React from "react";
import "../css/Pricing.css";

const Pricing = () => {
  return (
    <div className="pricing6">

      {/* ================= HERO ================= */}
      <section className="pr6-hero">
        <span className="pr6-tag">PRICING</span>
        <h1>Membership Structure</h1>
        <p>
          Simple plans built around consistency, recovery,
          and sustainable performance.
        </p>
      </section>

      {/* ================= PLANS ================= */}
      <section className="pr6-plans">

        <div className="pr6-plan">
          <h3>Base Access</h3>
          <div className="price">$39<span>/month</span></div>

          <ul>
            <li>Open gym access</li>
            <li>Structured weekly templates</li>
            <li>Mobility & recovery zones</li>
            <li>Community sessions</li>
          </ul>
        </div>

        <div className="pr6-plan featured">
          <span className="badge">Most Chosen</span>
          <h3>Guided Training</h3>
          <div className="price">$69<span>/month</span></div>

          <ul>
            <li>Everything in Base</li>
            <li>Coach-led sessions</li>
            <li>Movement assessments</li>
            <li>Progress monitoring</li>
          </ul>
        </div>

        <div className="pr6-plan">
          <h3>Performance+</h3>
          <div className="price">$119<span>/month</span></div>

          <ul>
            <li>Personal coaching</li>
            <li>Customized training blocks</li>
            <li>Recovery programming</li>
            <li>Priority scheduling</li>
          </ul>
        </div>

      </section>

      {/* ================= COMPARISON ================= */}
      <section className="pr6-compare">
        <h2>Plan Comparison</h2>

        <div className="pr6-table">

          <div className="pr6-row header">
            <span>Feature</span>
            <span>Base</span>
            <span>Guided</span>
            <span>Performance+</span>
          </div>

          <div className="pr6-row">
            <span>Open Gym</span>
            <span>✓</span>
            <span>✓</span>
            <span>✓</span>
          </div>

          <div className="pr6-row">
            <span>Coach-Led Sessions</span>
            <span>—</span>
            <span>✓</span>
            <span>✓</span>
          </div>

          <div className="pr6-row">
            <span>Movement Assessments</span>
            <span>—</span>
            <span>✓</span>
            <span>✓</span>
          </div>

          <div className="pr6-row">
            <span>Personal Coaching</span>
            <span>—</span>
            <span>—</span>
            <span>✓</span>
          </div>

          <div className="pr6-row">
            <span>Recovery Programming</span>
            <span>Basic</span>
            <span>Guided</span>
            <span>Advanced</span>
          </div>

        </div>
      </section>

      {/* ================= FOOT NOTE ================= */}
      <section className="pr6-note">
        <p>
          All memberships are month-to-month. No long-term contracts.
          Adjust or upgrade anytime.
        </p>
      </section>

    </div>
  );
};

export default Pricing;
